import MarkdownIt from 'markdown-it';
import { dateFormat } from '@/utils/filters';
import style from './style.module.scss';
import { useEffect } from 'react';
import { useRef } from 'react';
import ContentAnchor, { AnchorRef } from './ContentAnchor';
import ImageViewer, { ImageRef } from './ImageViewer';
const namespace = 'sl-content';
const mdit = new MarkdownIt({
  html: true,
  xhtmlOut: true,
  breaks: true,
  linkify: true,
});
interface DocTemplateProps {
  title: string;
  time: number;
  content: string;
  html?: string;
  showAnchor?: boolean;
  tag?: string[];
}

export const DocHeader = ({
  tag,
  time,
  title,
}: {
  tag: string[];
  time: number;
  title: string;
}) => (
  <div className={style['doc-header']}>
    <h1 className={`${namespace}-heading-h1`}>{title}</h1>
    <div className={`${namespace}-inline`}>
      {tag && <span className={style.tag}>{tag}</span>}
      <div className={`${namespace}-date`}>更新时间：{dateFormat(time)}</div>
    </div>
    <hr className={`${namespace}-horizontalRule`} />
  </div>
);

export default function DocTemplate({
  title,
  time,
  content,
  showAnchor = false,
  html,
  tag,
}: DocTemplateProps) {
  const anchorRef = useRef<AnchorRef>(null);
  const imageRef = useRef<ImageRef>(null);
  const containerDom = useRef<HTMLDivElement>(null);

  const activatePlugins = () => {
    const anchor = anchorRef.current;
    anchor?.display();
    const imageViewer = imageRef.current;
    const clearRegistry = imageViewer?.register(namespace);
    return () => {
      clearRegistry();
    };
  };

  useEffect(() => {
    if (!showAnchor) return;
    const clearPlugins = activatePlugins();
    return () => {
      clearPlugins();
    };
  }, [html, content]);

  return (
    <div className={style['doc-template-wrapper']}>
      <div className={style['doc-template-container']}>
        <DocHeader title={title} tag={tag} time={time} />
        {/* <div id={namespace} className={namespace} ref={containerDom} /> */}
        <div
          id={namespace}
          className={namespace}
          dangerouslySetInnerHTML={{
            __html: html ?? mdit.render(content),
          }}
        />

        <ImageViewer ref={imageRef} container={containerDom.current} />
      </div>
      {showAnchor && (
        <ContentAnchor ref={anchorRef} scope={namespace} limit={5} />
      )}
    </div>
  );
}
